import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ButtonPrimary } from '@klarna/bubble-ui';

const styles = {
  outerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 140,
  },
};

const CallToActionButton = ({ onClick, children, disabled = false, loading = false, ...props }) => {
  return (
    <div style={props.customOuterContainerStyles || styles.outerContainer}>
      <div style={props.customInnerContainerStyles || styles.innerContainer}>
        <ButtonPrimary
          {...props}
          type="submit"
          onClick={onClick}
          disabled={disabled}
          loading={loading}
        >
          {children}
        </ButtonPrimary>
      </div>
    </div>
  );
};

CallToActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  customInnerContainerStyles: PropTypes.object,
  customOuterContainerStyles: PropTypes.object,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default CallToActionButton;
